export function toE164(phoneNumber: string): string {
    // Remove all non-digit characters
    const digits = phoneNumber.trim().replace(/[^\d]/g, '');

    // Check if the number is valid for US/Canada
    if (digits.length === 10 || (digits.length === 11 && digits.startsWith('1'))) {
        if (digits.length === 10) {
            return `+1${digits}`;
        } else if (digits.startsWith('1')) {
            return `+${digits}`;
        }
    }

    // If it doesn't match the format, return the original number
    return phoneNumber;
}
